import React, { useReducer, useEffect } from 'react';
import styles from "./SingleSelectFilterPicker.module.scss";
import { FilterPicker } from "../FilterPicker";
import { RadioButtonWithLabel } from "../RadioButtonWithLabel";
import { createReducer, getInitialSelection } from "./SingleSelectFilterPicker.reducer";
export function SingleSelectFilterPicker(props) {
  const {
    label,
    options,
    onChange,
    value
  } = props;
  const [state, dispatchAction] = useReducer(createReducer(), getInitialSelection());
  const isControlled = typeof value !== 'undefined';
  useEffect(() => {
    if (isControlled) {
      let index;
      const option = options.find((optionObj, ObjIndex) => {
        if (optionObj.value === value) {
          index = ObjIndex;
          return true;
        }
      });

      if (option && typeof index !== 'undefined') {
        dispatchAction({
          //todo - don't re-dispatch if already selected
          type: 'selectOption',
          value: {
            index
          }
        });
        dispatchAction({
          type: 'applyChanges',
          label: option.label
        });
      }
    }
  }, [isControlled, value, options]);
  return /*#__PURE__*/React.createElement(FilterPicker, {
    "data-testid": props['data-testid'],
    label: state.labelToDisplay || label,
    highlightTrigger: state.selectedOptionIndex !== 0,
    title: label,
    onApply: () => {
      if (state.selectedOptionIndex === state.previousState.selectedOptionIndex) return;
      const option = options[state.selectedOptionIndex];

      if (!isControlled) {
        dispatchAction({
          type: 'applyChanges',
          label: option.label
        });
      }

      onChange(option, state.selectedOptionIndex);
    },
    onClose: opts => {
      if (opts !== null && opts !== void 0 && opts.revert) {
        dispatchAction({
          type: 'revert'
        });

        if (isControlled) {
          onChange();
        }
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.radioGroup
  }, options.map((option, index) => {
    return /*#__PURE__*/React.createElement(RadioButtonWithLabel, {
      key: option.value,
      testId: "".concat(props['data-testid'], "-item-").concat(option.value),
      label: option.label,
      sublabel: option.counter ? "(".concat(option.counter, ")") : null,
      checked: state.selectedOptionIndex === index,
      onChange: () => {
        dispatchAction({
          type: 'selectOption',
          value: {
            index
          }
        });
      }
    });
  })));
}